// Simple module-level state for controlling command palette from anywhere
let openCallback: (() => void) | null = null;
let lastCloseTime = 0;
const REOPEN_DELAY = 200; // ms to wait before allowing reopen after close

export function registerCommandPaletteOpener(callback: () => void) {
	openCallback = callback;
}

export function openCommandPalette() {
	// Prevent immediate reopen after closing
	const now = Date.now();
	if (now - lastCloseTime < REOPEN_DELAY) {
		return;
	}

	if (openCallback) {
		openCallback();
	}
}

export function notifyCommandPaletteClosed() {
	lastCloseTime = Date.now();
}

// For testing: reset state
export function _resetCommandPaletteState() {
	openCallback = null;
	lastCloseTime = 0;
}
